'use client'
import { PreviewBoutiqueGridBlock } from '@/payload-types'
import RichText from '@onclicks/sharedcomponents/RichText'
import { CMSLink } from '../../CMSLink'
import { useFetchProducts } from '@onclicks/sharedmedusa/hooks/useFetchProducts'
import { useState } from 'react'
import Card from './Card/Card'
import { ChevronLeftIcon, ChevronRightIcon } from 'flowbite-react'
import { cn } from '@/utilities/ui'
import { bagelFatOne, quicksand } from '@/utilities/fontImport'

const ProductCardsGrid: React.FC<PreviewBoutiqueGridBlock> = (data) => {
  const { title, richText, links, categoryHandle, onlyPromotions } = data
  const { products, loading } = useFetchProducts({
    countryCode: process.env.NEXT_PUBLIC_MEDUSA_REGION ?? 'be',
    categoryHandle,
    onlyPromotions: !!onlyPromotions,
  })

  const productsPerPage = 4

  const [indexOfFirstProduct, setIndexOfFirstProduct] = useState(0)
  const indexOfLastProduct = indexOfFirstProduct + productsPerPage
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct)
  const totalPages = Math.ceil(products.length / productsPerPage)

  const nextStepProduct = () => {
    setIndexOfFirstProduct((prev) => prev + 1)
  }

  const backStepProduct = () => {
    setIndexOfFirstProduct((prev) => prev - 1)
  }

  return (
    <section id="products" className="px-6 lg:px-34 py-10">
      {title && (
        <h1 className={`text-primary text-4xl font-bold mb-6 ${bagelFatOne.className}`}>{title}</h1>
      )}
      {richText && (
        <RichText
          data={richText}
          enableGutter={false}
          className={`mb-4 mt-2 text-lg ${quicksand.className}`}
        />
      )}
      <div className="flex flex-col lg:flex-row items-center lg:gap-x-25">
        <div className="grid grid-cols-1 md:grid-cols-4 mx-auto my-8 w-full gap-6">
          {loading
            ? [1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="animate-pulse bg-gray-300 h-48 rounded-2xl mb-5 flex justify-center items-center"
                />
              ))
            : currentProducts.map((product, index) => <Card key={index} product={product} />)}
        </div>
      </div>

      {!loading && totalPages > 1 && (
        <div className="flex w-full justify-center mb-8">
          <div className="flex justify-center items-center gap-3">
            <button
              onClick={() => backStepProduct()}
              disabled={indexOfFirstProduct === 0}
              className={cn(
                'px-4 py-4 font-bold text-white rounded-full bg-linear-to-b from-orange to-light-red hover:from-light-red hover:to-orange transition duration-200',
              )}
            >
              <ChevronLeftIcon />
            </button>

            <button
              onClick={() => nextStepProduct()}
              disabled={indexOfLastProduct === products.length}
              className={cn(
                'px-4 py-4 text-white rounded-full bg-linear-to-b from-light-red to-orange hover:from-orange hover:to-light-red transition duration-200',
              )}
            >
              <ChevronRightIcon />
            </button>
          </div>
        </div>
      )}

      <div className=" max-w-2xl lg:shrink-0 lg:text-left">
        {links && links.map((link, index) => <CMSLink key={index} {...link.link} />)}
      </div>
    </section>
  )
}

export default ProductCardsGrid
